import { render, staticRenderFns } from "./RinvD_Total.vue?vue&type=template&id=57a83901"
import script from "./RinvD_Total.vue?vue&type=script&lang=js"
export * from "./RinvD_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports